import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {AperzaLinkUtil} from '@aperza/util';
import CatalogCard from './CatalogCard';

const CatalogList = (props) => {

  let {
    disablePreview = false,
    columns = 6
  } = props;

  const {t} = useTranslation();

  const renderCatalogs = (catalogs = []) => {
    return catalogs.map((catalog, index) => {
      let catalogPreviewImageUrls = [];
      if (catalog.catalog.previewImageUrl1) catalogPreviewImageUrls.push(catalog.catalog.previewImageUrl1);
      if (catalog.catalog.previewImageUrl2) catalogPreviewImageUrls.push(catalog.catalog.previewImageUrl2);
      if (catalog.catalog.previewImageUrl3) catalogPreviewImageUrls.push(catalog.catalog.previewImageUrl3);

      let data = {
        title: catalog.document.documentName,
        description: catalog.catalog.documentDescription,
        companyName: catalog.catalog.companyNameLangValue,
        companyLogoUrl: catalog.catalog.companyLogoUrlLangValue,
        companyPageUrl: AperzaLinkUtil.createCompanyPageUrl({companyContractDisplayId: catalog.catalog.companyContractDisplayId}),
        tags: [catalog.document.documentType=='CATALOG'?t('tag.catalog'):undefined],
        catalogImageUrl: catalog.catalog.imageUrl1,
        catalogVideoId: catalog.catalog.videoUrl,
        catalogPageUrl: AperzaLinkUtil.createCatalogPageUrl({companyContractDisplayId: catalog.catalog.companyContractDisplayId, catalogId: catalog.catalog.cluezCatalogId}),
        catalogPreviewImageUrls,
        companyContractDisplayId: catalog.catalog.companyContractDisplayId,
        companyId: catalog.catalog.cluezCompanyId,
        catalogId: catalog.catalog.cluezCatalogId,
        fileSize: catalog.document.documentSizeBytes,
      };
      return <CatalogCard columns={columns} key={index} {...data} disablePreview={disablePreview} />;
    });

  };

  useEffect(() => {
    $('.matchHeight .img img').off('load').on('load', function(){
      try {
        $('.matchHeight .img').matchHeight();
      } catch (ex) {
        console.warn('matchHeight is not available');
      }
    });
  },[props.catalogs]);

  return (
    <React.Fragment>
      <ul className="product-list highlight row mb-5 matchHeight">
        {renderCatalogs(props.catalogs)}
      </ul>
    </React.Fragment>
  );

};

CatalogList.propTypes = {
  catalogs: PropTypes.array,
  selectedCatalog: PropTypes.number,
  selectedVideoUrl: PropTypes.string,
  disablePreview: PropTypes.bool,
  modalOpen: PropTypes.bool,
  modalVideoOpen: PropTypes.bool,
  columns: PropTypes.string
};

export default CatalogList;
